import "./style.scss";

export const Divider = ({ vertical = false, noMargin = false }) => {
  return (
    <div
      className={`${vertical ? "vertical-divider" : "horizontal-divider"} ${noMargin ? "divider-no-margin" : "divider-margin"}`}
    ></div>
  );
};
